import { RowData } from '../types';

/**
 * Generates the triangular rows based on the Shifting Arithmetic algorithm.
 */
export const generateRows = (
  root: number,
  base: number,
  power: number,
  weight: number,
  method: 'full' | 'contracted'
): RowData[] => {
  const rows: RowData[] = [];

  let currentElements = [root];
  rows.push({
    level: 0,
    elements: [...currentElements],
    sum: root,
    expectedSum: root * Math.pow(base, 0),
  });

  for (let c = 1; c <= power; c++) {
    let nextElements: number[] = [];

    if (method === 'full') {
      currentElements.forEach((x) => {
        for (let i = 0; i < base; i++) {
          const shift = (i - (base - 1) / 2) * ((weight * 2) / (base - 1 || 1));
          nextElements.push(Number((x + shift).toFixed(4)));
        }
      });
    } else {
      const prevLen = currentElements.length;
      const nextLen = prevLen + (base - 1);
      nextElements = new Array(nextLen).fill(0);

      for (let i = 0; i < prevLen; i++) {
        const x = currentElements[i];
        for (let j = 0; j < base; j++) {
          nextElements[i + j] += x;
        }
      }

      if (weight !== 0) {
        nextElements[0] = Number((nextElements[0] - weight).toFixed(4));
        nextElements[nextElements.length - 1] = Number(
          (nextElements[nextElements.length - 1] + weight).toFixed(4)
        );
      }

      nextElements = nextElements.map((v) => Number(v.toFixed(4)));
    }

    currentElements = nextElements;
    const currentSum = currentElements.reduce((a, b) => a + b, 0);
    rows.push({
      level: c,
      elements: [...currentElements],
      sum: Number(currentSum.toFixed(4)),
      expectedSum: root * Math.pow(base, c),
    });
  }
  return rows;
};
